export default __webpack_public_path__ + "static/media/Licenses_IMG-License-05.30d5bad3.png";